import type { ManualEstimateReviewStage } from "@rebuild/shared";
import { STAGE_BADGE_CLASSES } from "./manualEstimateReviewsUtils";

function StageBadge({ stage }: { stage: ManualEstimateReviewStage }) {
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${STAGE_BADGE_CLASSES[stage]}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {stage}
    </span>
  );
}

export default StageBadge;
